<template lang="pug">
v-navigation-drawer(
  v-model="showSidebar"
  temporary
  absolute
  style="z-index:10000; position:fixed")
  v-list-item
    v-list-item-avatar
      v-img(src="@/assets/male.png")
    v-list-item-content
      v-list-item-title {{ email }}

  v-divider(class="mt-2")

  v-list(class="mb-12" dense)
    v-list-item(
      v-if="hasPermission(item.permission)"
      v-for="item in items"
      :to="item.url"
      :key="item.title"
      link)
      v-list-item-icon
        v-icon {{ item.icon }}
      v-list-item-content
        v-list-item-title {{ item.title }}

  support-button
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import SupportButton from '@/components/ui/SupportButton.vue';

export default {
  name: 'SideBar',

  components: {
    SupportButton,
  },

  data: () => ({
    items: [
      {
        title: 'Usuarios',
        url: '/users',
        icon: 'mdi-account-group',
        permission: 'is_superuser',
      },
      {
        title: 'Lista Folios',
        url: '/folios',
        icon: 'mdi-file-multiple',
      },
      {
        title: 'Documentos',
        url: '/documents',
        icon: 'mdi-file-certificate-outline',
      },
      {
        title: 'Buscar bases Catastrales',
        url: '/search',
        icon: 'mdi-book-search-outline',
      },
      {
        title: 'Familia Registral',
        url: '/family',
        icon: 'mdi-family-tree',
      },
      {
        title: 'Comparación Catastral',
        url: '/cadastral_comparison',
        icon: 'mdi-compare',
      },
      {
        title: 'Colindancia Catastral',
        url: '/cadastral_adjacency',
        icon: 'mdi-land-plots-circle',
      },
      {
        title: 'Cargar Folios',
        url: '/upload',
        icon: 'mdi-upload',
      },
      {
        title: 'Consulta VUR',
        url: '/vur',
        icon: 'mdi-database-search-outline'
      },
      {
        title: 'VUR masivo',
        url: '/massive-vur',
        icon: 'mdi-download-multiple',
        permission: 'can_massive_vur',
      },
      {
        title: 'Diccionario especificaciones',
        url: '/especifications',
        icon: 'mdi-clipboard-list',
      },
      {
        title: 'Círculos registrales',
        url: '/map',
        icon: 'mdi-map-outline',
      },
      {
        title: 'Listas Restrictivas',
        url: '/restrictive-lists',
        icon: 'mdi-account-alert'
      },
      {
        title: 'Reporte API',
        url: '/api-report',
        icon: 'mdi-file-excel-outline'
      },
      {
        title: 'Pre-Diagnóstico Dinámico',
        url: '/dynamic-report',
        icon: 'mdi-file-chart'
      },
      
      {
        title: 'VUR Propietarios',
        url: '/owner-vur',
        icon: 'mdi-home-group-plus'
      },
      {
        title: 'Búsqueda Masiva',
        url: '/massive-search',
        icon: 'mdi-text-search'
      },
      {
        title: 'Descargar PDFs',
        url: '/download-pdfs',
        icon: 'mdi-file-pdf-box'
      },
      {
        title: 'Conversor Coordenadas',
        url: '/conversor',
        icon: 'mdi-map-marker-distance'
      },
      {
        title: 'Cambiar contraseña',
        url: '/change-password',
        icon: 'mdi-account-key'
      },
      {
        title: 'Credenciales VUR',
        url: '/vur-credentials',
        icon: 'mdi-lock-plus'
      },
    ],
  }),

  computed: {
    ...mapState('auth', ['email']),
    ...mapGetters('auth', ['hasPermission']),
    showSidebar: {
      get() {
        return this.$store.state.ui.showSidebar;
      },
      set(value) {
        return this.$store.commit('ui/TOGGLE_SIDEBAR', value);
      }
    }
  }
};
</script>
